import { messenger as base } from '../base';
import { messenger as AT } from './AT';
import { messenger as CZ } from './CZ';
import { messenger as RO } from './RO';

export const featureConfigMap = {
    base,
    AT,
    CZ,
    RO,
};
